import { Button, Center, Flex, Grid, GridItem, useMediaQuery, Text, Box, HStack } from "@chakra-ui/react";
import ImagePlacementItem from "./ImagePlacementItem";
import { ImageSortingTask, PlacementPoint } from "data-models/task-models";
import { useFollowUp, QUESTION_ACTIONS } from "providers/FollowUpProvider";
import ImagePlacementPoint from "./ImagePlacementPoint";
import Ellipse from "../../../../../assets/images/Ellipse.svg";
import Square from "../../../../../assets/images/Square.svg";
import Triangle from "../../../../../assets/images/Triangle.svg";
import Rectangle from "../../../../../assets/images/Rectangle.svg";
import { RepeatIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { apiBase } from "services/config";
import { tasksWithDropImages, IMAGE_BOX_HEIGHT, IMAGE_WIDTH, MAX_GRID_WIDTH } from "./tasksWithDropImages";

interface ImagePlacementImagesContainerProps {
  images: string[];
  resetCards?: boolean;
  handleReset?: () => void;
}

export const ImagePlacementImagesContainer = ({
  images,
  resetCards,
  handleReset,
}: ImagePlacementImagesContainerProps) => {
  const { currentTask, dispatch } = useFollowUp();
  const task = currentTask as ImageSortingTask;
  const { t, i18n } = useTranslation();
  const gridColumnNumber = task.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? 6 : task.images.length;

  //we have another array for count numbers task, as the image answer includes the number 3,4,5,6,9 not like the normal ones - 1,2,3,4,5
  const countNumbersTask =
    currentTask.title[1] ===
    "Which number matches the number of dots on the die? Drag each dice to its corresponding number.";

  const sortShapesTask = currentTask.name[1] === "Shapes" && currentTask.knowledge[1] === "Mathematics level 1";

  const sortShapesTaskLevel2 = currentTask.name[1] === "Shapes" && currentTask.knowledge[1] === "Mathematics level 2";

  const countNumbersTaskArray = [3, 4, 5, 6, 9];

  const sortShapesTaskArray = [Ellipse, Ellipse, Ellipse, Square, Square, Square];

  const sortShapesLevel2Array = [Ellipse, Ellipse, Square, Square, Triangle, Triangle, Rectangle, Rectangle];

  const changePlacement = (newXY: PlacementPoint, draggedItem: string) => {
    const movedItemIndex = task.placementPoints.findIndex(pp => pp.id === newXY.id);
    dispatch({
      type: QUESTION_ACTIONS.UPDATE_IMAGE_SORTING_ANSWER,
      payload: { placedAtPoint: draggedItem, index: movedItemIndex },
    });
    //  }

    dispatch({ type: QUESTION_ACTIONS.UNSKIP_CURRENT_TASK });
  };

  const [isSmallScreen] = useMediaQuery("(max-height: 900px)");

  const labelsBelowBoxes = [t("Vegetable_Text"), t("Animal_Text"), t("Cloth_Text"), t("Tool_Text")];

  const [isSoundPlaying, setIsSoundPlaying] = useState({});
  const playSound = soundUrl => {
    const audio = new Audio(soundUrl);
    audio.play();
    setIsSoundPlaying(prevState => ({
      ...prevState,
      [soundUrl]: true,
    }));
    audio.onended = () =>
      setIsSoundPlaying(prevState => {
        const newState = { ...prevState };
        delete newState[soundUrl];
        return newState;
      });
  };

  const hasDropImage = tasksWithDropImages.includes(currentTask.id);

  return (
    <Flex flexDir={"row"} alignContent={"center"} justifyContent={"center"} m="0 auto">
      {task.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? (
        <Grid h="full" w="full" templateColumns="auto 60px auto" gap={5} justifyContent="center" alignContent="center">
          <GridItem>
            <Grid
              gridTemplateColumns={`repeat(4, minmax(50px, ${MAX_GRID_WIDTH}))`}
              gridTemplateRows={`repeat(2, minmax(50px, ${MAX_GRID_WIDTH}))`}
              gap={5}
            >
              {images.map((ao, index) => (
                <GridItem key={`${ao}_without_image ${index} ${currentTask.id}`}>
                  {ao !== "" ? (
                    <Center bgColor="white" width="full" height="full" borderRadius="2xl">
                      <ImagePlacementItem key={`${ao}_without_image ${index} image_placement_comp`} ipa={ao} />
                    </Center>
                  ) : (
                    <Center
                      width="full"
                      height="full"
                      borderRadius="2xl"
                      borderWidth="1px"
                      borderStyle="dashed"
                      borderColor="white"
                      color="overlayWhite"
                      fontSize="48"
                      fontWeight="semibold"
                    ></Center>
                  )}
                </GridItem>
              ))}
            </Grid>
          </GridItem>

          <GridItem />

          <GridItem>
            <Grid
              gridTemplateColumns={`repeat(2, minmax(50px, ${MAX_GRID_WIDTH}))`}
              gridTemplateRows={`repeat(2, minmax(50px, ${MAX_GRID_WIDTH}))`}
              gap={5}
            >
              {task.placementPoints.map((pp, index) => {
                const soundUrl = pp?.soundUrl ? pp.soundUrl : [];
                const url =
                  i18n.language === "se"
                    ? apiBase + soundUrl[0]
                    : i18n.language === "de"
                      ? apiBase + soundUrl[2]
                      : apiBase + soundUrl[1];

                return (
                  <GridItem
                    key={`${pp.id}_${currentTask.id}`}
                    gridRow={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? (index < 2 ? 1 : 2) : 2}
                    mb={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? "4" : "0"}
                    mt={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? "2" : "0"}
                  >
                    <ImagePlacementPoint currentPoint={pp} onChange={changePlacement} text="" answerIndex={index} />
                    <HStack justifyContent={"center"}>
                      <Text mt="2" textAlign="center">
                        {labelsBelowBoxes[index]}
                      </Text>

                      <div
                        className={`soundIcon ${isSoundPlaying[url] ? "animateAudioIcon" : ""}`}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "10px",
                          width: "25px",
                          height: "25px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          background: isSoundPlaying[url] ? "white" : "#2a0f74",
                        }}
                      >
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault();
                            playSound(url);
                          }}
                        >
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="1.5"
                            stroke={isSoundPlaying[url] ? "black" : "currentColor"}
                            width="15"
                            height="15"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
                            />
                          </svg>
                        </a>
                      </div>
                    </HStack>
                  </GridItem>
                );
              })}
            </Grid>
          </GridItem>
          <GridItem colStart={3} display="flex" justifyContent="flex-end" mt="4">
            <Button
              py="4"
              px="3"
              fontSize="18px"
              rightIcon={<RepeatIcon />}
              onClick={handleReset}
              bg="transparent"
              variant="outline"
            >
              {t("Reset_Text")}
            </Button>
          </GridItem>
        </Grid>
      ) : (
        <Grid
          h="full"
          w="full"
          gridTemplateColumns={`repeat(${gridColumnNumber}, minmax(50px, ${isSmallScreen ? "150px" : "200px"}))`}
          gridTemplateRows={`repeat(${hasDropImage ? 1 : 2}, minmax(50px, ${
            hasDropImage ? "100px" : isSmallScreen ? "150px" : "200px"
          }))`}
          gridGap={"5"}
          justifyContent="center"
          alignContent="center"
        >
          {images.map((ao, index) => (
            <GridItem
              key={`${ao}_without_image ${index} ${currentTask.id}`}
              gridRow={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? (index < 4 ? 1 : 2) : 1}
              height={hasDropImage ? IMAGE_BOX_HEIGHT : "full"}
              m={hasDropImage ? "0 auto" : 0}
            >
              {ao !== "" ? (
                <Center
                  bgColor="white"
                  width={hasDropImage ? IMAGE_WIDTH : "full"}
                  height={hasDropImage ? IMAGE_BOX_HEIGHT : "full"}
                  borderRadius="2xl"
                  m={hasDropImage ? "0 auto" : 0}
                >
                  <ImagePlacementItem key={`${ao}_without_image ${index} image_placement_comp`} ipa={ao} />
                </Center>
              ) : (
                <Center
                  width={hasDropImage ? IMAGE_WIDTH : "full"}
                  height={hasDropImage ? IMAGE_BOX_HEIGHT : "full"}
                  borderRadius="2xl"
                  borderWidth="1px"
                  borderStyle="dashed"
                  borderColor="white"
                  color="overlayWhite"
                  fontSize="48"
                  fontWeight="semibold"
                ></Center>
              )}
            </GridItem>
          ))}

          {task.placementPoints.map((pp: any, index) => {
            return (
              <GridItem
                key={`${pp.id}_${currentTask.id}`}
                gridRow={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? (index < 2 ? 1 : 2) : 2}
                mb={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? "2" : "0"}
                mt={currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" ? "2" : "0"}
              >
                <ImagePlacementPoint
                  key={`${pp.id} image_placement_point`}
                  currentPoint={pp}
                  onChange={changePlacement}
                  text={
                    currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b"
                      ? ""
                      : countNumbersTask
                        ? countNumbersTaskArray[index]
                        : sortShapesTask
                          ? sortShapesTaskArray[index]
                          : sortShapesTaskLevel2
                            ? sortShapesLevel2Array[index]
                            : index + 1
                  }
                  answerIndex={index}
                  dropImages={currentTask.dropImages?.[index]}
                />
                {currentTask.id === "d9a35239-f060-456d-9aef-88cf422c010b" && (
                  <Text mt="2" textAlign={"center"}>
                    {labelsBelowBoxes[index]}
                  </Text>
                )}
              </GridItem>
            );
          })}

          <GridItem gridRow={3} gridColumn={gridColumnNumber} display="flex" justifyContent="end" mt="3">
            <Button
              py="4"
              px="3"
              fontSize="18px"
              rightIcon={<RepeatIcon />}
              onClick={handleReset}
              bg="transparent"
              variant="outline"
            >
              {t("Reset_Text")}
            </Button>
          </GridItem>
        </Grid>
      )}
    </Flex>
  );
};
